
// Third Party
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

// UI
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Skeleton } from "@/components/ui/skeleton";


// Icons
import {
    ArrowLeft,

} from "lucide-react";



// Services and Types
import {
    getConversationDetail
} from "@/services/chat";
import type { ConversationDetail, UserList } from "@/types/chat";
import { CHAT_AVATAR_SMALL, CHAT_BUCKET_LINK } from "@/components/constants";

export const Route = createFileRoute(
    "/_layout-private/chat/_layout/group/$id/info",
)({
    component: RouteComponent,
});

function RouteComponent() {
    const { id } = Route.useParams();

    // Query
    const { data, isLoading } = useQuery({
        queryKey: ["conversation-detail", id],
        queryFn: () => getConversationDetail(id as string),
    });

    if (isLoading) {
        return <Skeleton className="w-full h-[200px] rounded-md" />;
    }

    const detail = data?.data as ConversationDetail;


    return (
        <div className="h-full overflow-y-auto max-h-[calc(100vh-200px)]">
            <header className="flex relative justify-center items-center p-4 border-b">
                <button
                    onClick={() => window.history.back()}
                    className="flex absolute left-4 items-center text-sm transition-colors hover:text-primary"
                >
                    <ArrowLeft className="mr-2 w-[16px] h-[16px]" />
                    <span>ກັບຄືນ</span>
                </button>

                <h2 className="font-bold text-[18px]">ຂໍ້ມູນກ່ຽວກັບກຸ່ມ</h2>
            </header>

            <div className="flex flex-col items-center text-sm gap-[24px] p-[28px]">
                <Avatar className="w-[120px] h-[120px] cursor-pointer group-hover:opacity-80">
                    <AvatarImage
                        className="object-cover"
                        src={`${CHAT_BUCKET_LINK}/images/${detail?.conversationImage}`}
                    />
                    <AvatarFallback>{detail?.conversationName?.charAt(0)}</AvatarFallback>
                </Avatar>

                <div className="flex flex-col items-center">
                    <h2>{detail?.conversationName}</h2>
                    <p className="text-muted-foreground">ກຸ່ມສົນທະນາ</p>
                </div>



                <div className="w-full">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="font-semibold">
                            ສະມາຊິກໃນກຸ່ມ ({detail?.participants?.length || 0})
                        </h3>

                    </div>

                    <div className="space-y-3 max-h-[300px] overflow-y-auto pr-2">
                        {detail?.participants?.map((participant) => (
                            <div
                                key={participant._id}
                                className="flex justify-between items-center p-2 rounded-md hover:bg-slate-50"
                            >
                                <div className="flex gap-3 items-center">
                                    <Avatar className="w-10 h-10">
                                        <AvatarImage
                                            src={
                                                participant?.user?.profileUrl
                                                    ? CHAT_AVATAR_SMALL + participant?.user?.profileUrl
                                                    : undefined
                                            }
                                            className="object-cover"
                                        />
                                        <AvatarFallback className="bg-primary/10 text-primary">
                                            {participant.user?.fullName?.charAt(0) || "U"}
                                        </AvatarFallback>
                                    </Avatar>
                                    <div>
                                        <p className="text-sm font-medium">
                                            {participant?.user?.fullName}
                                        </p>
                                        <p className="text-xs text-muted-foreground">
                                            {participant?.isAdmin ? "ຜູ້ບໍລິຫານກຸ່ມ" : "ສະມາຊິກ"}
                                        </p>
                                    </div>
                                </div>


                            </div>
                        ))}
                    </div>









                </div>
            </div>
        </div>
    );
}
